<template>
    <div class="mobile-filters">
        <v-btn text class="text--main-yellow" @click="drawer = !drawer">
            <v-icon left>tune</v-icon>
            {{ $t('filterTo') }}
        </v-btn>
        <v-navigation-drawer
            v-model="drawer"
            fixed
            width="100%"
            class="pt-5"
        >
            <v-toolbar class="fixed-top-toolbar">
                <v-btn class="pl-1" icon @click="drawer = false">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <span class="font-weight-bold pl-2">{{ $t('filterTo')}}</span>
                <v-spacer></v-spacer>
                <v-btn class="mr-2" text @click="cancelFilters">
                    <span class="font-weight-medium text-uppercase">{{ $t('cancelFilters')}}</span>
                </v-btn>
            </v-toolbar>
            <div class="pt-12">
                <general-filters
                    :id="getId"
                    :systemName="getName"
                    :total="total"
                    :filter-key="filterKey"
                    ref="generalFilters"
                    @update-list="updateList"
                    @apply="drawer = false"
                ></general-filters>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import GeneralFilters from "./GeneralFilters";

    export default {
        name: "MobileFilters",
        props: ['attributeId', 'attributeName', 'total', 'categoryId', 'categoryName', 'filterKey', 'regionId', 'attributeSystemName'],
        components: {GeneralFilters},
        data() {
            return {
                drawer: false
            }
        },
        computed: {
            getId() {
                switch (this.filterKey) {
                    case "attribute":
                        return this.attributeId;
                    case "category":
                        return this.categoryId;
                    case "region":
                        return  this.regionId;
                    default:
                        break;
                }
            },
            getName() {
                switch (this.filterKey) {
                    case "category":
                        return this.categoryName;
                    case "attribute":
                        return this.attributeName;
                    default:
                        break;
                }
            },
        },
        methods: {
            updateList() {
                this.$emit('update-list');
            },
            cancelFilters(){
                this.$refs.generalFilters.getFiltersLayout();
                this.$refs.generalFilters.resetLayout();
            }
        },
    }
</script>

<style scoped>

</style>
